module.exports = __webpack_public_path__ + "static/media/note.33670194.png";